import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, useController } from "react-hook-form";

import {
    FileUploaderInput,
    FileUploaderInputBaseProps,
} from "../fields/fileUploaderInput";

type RHFFileUploaderInputProps<TFieldsValues extends FieldValues> =
    BaseRHFWidgetProps<TFieldsValues, string[]> & FileUploaderInputBaseProps;

export function RHFFileUploaderInput<TFieldsValues extends FieldValues>({
    name,
    control,
    label,
    deleteAction,
    savedBlobs,
    disabled,
    emptyText,
    hideMissing,
    maxFiles,
    preUploadCallback,
}: RHFFileUploaderInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ name, control, disabled });

    return (
        <FileUploaderInput
            value={field.value}
            fieldRef={field.ref}
            onChange={field.onChange}
            error={fieldState.error?.message}
            onBlur={field.onBlur}
            label={label}
            deleteAction={deleteAction}
            savedBlobs={savedBlobs}
            disabled={field.disabled}
            emptyText={emptyText}
            hideMissing={hideMissing}
            maxFiles={maxFiles}
            preUploadCallback={preUploadCallback}
        />
    );
}
